import { render, staticRenderFns } from "./DocumentationView.vue?vue&type=template&id=95292566"
import script from "./DocumentationView.vue?vue&type=script&lang=js"
export * from "./DocumentationView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports